function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 95 86"
}, props), React.createElement("path", {
  d: "M46.433 68.95s-6.31.937-12.785-6.749M65.19 66.863S51.96 82.985 39.016 76.377M37.966 66.215s-3.187 8.217-10.24 2.765",
  stroke: "#5FB9D7",
  strokeWidth: "2",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M59.323 24.565l-.996 1.884v.001c-1.246 2.348-4.177 3.086-6.286 1.445l-1.662-1.29.57 2.273h0c.635 2.534-.871 5.238-3.448 5.696h0l-2.222.395 1.997 1.239h.002c2.2 1.37 2.776 4.427 1.343 6.589l-1.32 1.994 2.064-.608h.001c2.55-.749 5 1.075 5.395 3.684h0l.333 2.2.996-1.885v-.001c1.246-2.348 4.177-3.087 6.286-1.446l1.662 1.291-.57-2.274h-.001c-.634-2.534.872-5.237 3.449-5.696h0l2.222-.394-1.998-1.24h0c-2.2-1.369-2.777-4.427-1.344-6.588m-6.473-7.27l7.306 7.822m-7.306-7.821l.333 2.199h0c.395 2.608 2.845 4.433 5.394 3.684h.001l2.065-.608m-7.793-5.275l8.65 3.98m-2.177 3.289l.833.552m-.833-.552h0l.833.552m-.833-.552l1.32-1.994m-.487 2.546l1.977-2.985-1.49.439m0 0l.857-1.295m0 0l1.49-.439-1.49.439zm2.64 10.855l1.273.79-1.475.262.202-1.052z",
  fill: "#fff",
  stroke: "#5FB9D7",
  strokeWidth: "2"
}), React.createElement("path", {
  d: "M7.07 43.108c0-4.872 1.323-9.546 3.675-13.513v27.027C8.393 52.655 7.07 47.98 7.07 43.108z",
  fill: "#C0D2D6",
  stroke: "#5FB9D7",
  strokeWidth: "2"
}), React.createElement("path", {
  d: "M93.2 78.93l-13.109-7.124c-3.057-1.664-6.706-1-9.2 1.53-6.836 6.937-16.023 11.194-26.125 11.194-11.688 0-22.158-5.686-29.167-14.638C6.975 64.62 1.156 54.598 1.156 43.108c0-11.49 5.82-21.503 14.436-26.784",
  stroke: "#5FB9D7",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M15.594 16.333C23.014 6.851 34.305 1.04 46.824 1.75c18.87 1.07 34.343 17.239 36.023 37.626.31 3.733.152 7.373-.41 10.857-.606 3.75 1.168 7.475 4.304 9.186l6.468 3.522",
  stroke: "#5FB9D7",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M27.07 26.357s5.724 6.187 5.724 17.224c0 11.036-6.294 19.988-14.067 19.988v-31.4c0-7.249 3.273-14.123 8.897-18.044 5.495-3.827 12.078-5.905 18.28-5.553A29.911 29.911 0 0157.194 11.5M82.938 65.402l10.26 5.343",
  stroke: "#5FB9D7",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));